import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

export const appId = 'default-app-id'; 
// Constante global de tenant com barra final para ser usada de forma uniforme: DB_PATH + 'colecao'
export const DB_PATH = `artifacts/${appId}/public/data/`;

const firebaseConfig = {
  apiKey: "AIzaSyAm_sOKndqhqyMz2fm9WWApDDo8iYv1ZQE",
  authDomain: "apex-grupoacadcontabilidade.firebaseapp.com",
  projectId: "apex-grupoacadcontabilidade",
  storageBucket: "apex-grupoacadcontabilidade.firebasestorage.app",
  messagingSenderId: "450158161974",
  appId: "1:450158161974:web:abd2a8c283c59791b66897",
  measurementId: "G-PVRC2MCBYM"
};

let app, db, auth, googleProvider;
try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  googleProvider = new GoogleAuthProvider();
  
  // Força a tela de seleção de conta do Google
  googleProvider.setCustomParameters({
    prompt: 'select_account'
  });
} catch (e) {
  console.error("Firebase initialization error:", e);
}

export { app, db, auth, googleProvider };
